// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__kKgPJ","control":"Checkout_control__MxNnf","actions":"Checkout_actions__+6Vtt","submit":"Checkout_submit__hFLqo","invalid":"Checkout_invalid__1qdvo"};